import React from 'react';
import { CandlestickChart, Filter, Table2, BellRing } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * HeroProductPreview - placeholder collage that mocks the four workspace
 * surfaces (filter modal, results table, chart, alert email).
 *
 * TODO(landing-screenshots): replace each tile body with a captured
 * production screenshot at 800x500 (see K12 in
 * STOCKBAI_HOMEPAGE_REWRITE_2026-05-09.md). Until captures land, the tiles
 * render labelled glyphs so the hero column is never empty.
 */
const TILES: Array<{
  iconKey: 'filter' | 'table' | 'chart' | 'alert';
  Icon: React.ElementType;
  titleKey: string;
}> = [
  { iconKey: 'filter', Icon: Filter, titleKey: 'landing.workflow.step1.title' },
  { iconKey: 'table', Icon: Table2, titleKey: 'landing.workflow.step2.title' },
  { iconKey: 'chart', Icon: CandlestickChart, titleKey: 'landing.workflow.step3.title' },
  { iconKey: 'alert', Icon: BellRing, titleKey: 'landing.workflow.step4.title' },
];

const HeroProductPreview: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div
      className="glass-card p-3 p-md-4 h-100"
      data-testid="hero-product-preview"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem',
      }}
      aria-label="Workspace preview"
    >
      <div
        className="row g-2 g-md-3 hero-preview-row"
        style={{ flex: 1 }}
      >
        {TILES.map(({ iconKey, Icon, titleKey }) => (
          <div key={iconKey} className="col-12 col-sm-6">
            <div
              className="h-100 p-3 rounded-3 d-flex flex-column gap-2 hero-preview-tile"
              style={{
                backgroundColor: 'var(--surface_container)',
                border: '1px solid var(--border-ghost)',
              }}
            >
              <Icon
                size={22}
                strokeWidth={1.75}
                style={{ color: 'var(--accent-primary)' }}
                aria-hidden
              />
              <div
                className="fw-semibold landing-card__title"
                style={{
                  fontFamily: 'var(--font-display)',
                  color: 'var(--text-primary)',
                  fontSize: '0.95rem',
                  lineHeight: 1.3,
                }}
              >
                {t(titleKey)}
              </div>
              <div
                className="mt-auto rounded-2"
                aria-hidden
                style={{
                  height: 6,
                  background:
                    'linear-gradient(90deg, var(--accent-primary) 0%, transparent 70%)',
                  opacity: 0.55,
                }}
              />
            </div>
          </div>
        ))}
      </div>
      <div
        className="text-uppercase small"
        style={{
          color: 'var(--text-muted)',
          letterSpacing: '0.08em',
          fontSize: '0.7rem',
        }}
      >
        Filter · Scan · Review · Alert
      </div>
    </div>
  );
};

export default HeroProductPreview;
